import React from 'react'
import { makeStyles } from '@material-ui/styles'
import UniversalSelect from 'app/components/UniversalSelect/UniversalSelect'

const useStyles = makeStyles({
  filterSelect: {
    paddingTop: 1,
    fontSize: 12,
    color: '#404040',
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      color: '#0073b1',
      padding: '9px 32px 9px 16px',
      backgroundColor: '#e5f1f7',
      borderRadius: 20,
    },
  },
  selectIcon: {
    position: 'absolute',
    right: 10,
    pointerEvents: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0073b1',
  },
  formControl: {
    borderRadius: '50px',
    backgroundColor: '#e5f1f7',
    width: '109px',
  },
})

export default (props) => {
  const { filter, onChangeFilterByKey } = props
  const classes = useStyles()

  return (
    <UniversalSelect
      options={[
        { id: 'All', label: 'topic.status.all' },
        { id: 'Active', label: 'status.active' },
        { id: 'Inactive', label: 'status.inactive' },
      ]}
      selected={filter['status']}
      className={classes.filterSelect}
      arrowStyle={classes.selectIcon}
      formStyle={classes.formControl}
      handleSelect={onChangeFilterByKey('status')}
    />
  )
}
